module.exports = __webpack_public_path__ + "assets/check-arrow-light.svg";